import { render, staticRenderFns } from "./RateView.vue?vue&type=template&id=8d76aae8&scoped=true&"
import script from "./RateView.vue?vue&type=script&lang=js&"
export * from "./RateView.vue?vue&type=script&lang=js&"
import style0 from "./RateView.vue?vue&type=style&index=0&id=8d76aae8&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8d76aae8",
  null
  
)

export default component.exports